import React from "react";

import styled from "styled-components";
import banner1 from "../assets/image/banner1.png";

export default function SlideBanner() {
  const SlideBanner = styled.div`
    width: 100%;

    & > img {
      width: 100%;
      height: auto;
    }
  `;
  return (
    <SlideBanner>
      <img src={banner1} alt="banner1.png" />
    </SlideBanner>
  );
}
